import { runCommandStreaming } from "../utils/exec.js";
import chalk from "chalk";

/**
 * Executes the package installation subprocess using the resolved package manager.
 */
export async function installDependency(
  cwd: string,
  pm: string,
  packageName: string,
  isDev: boolean,
  verbose: boolean
): Promise<{ success: boolean; details?: string; command: string }> {
  let command = "";
  if (pm === "pnpm") {
    command = `pnpm add ${isDev ? "-D " : ""}${packageName}`;
  } else if (pm === "yarn") {
    command = `yarn add ${isDev ? "-D " : ""}${packageName}`;
  } else if (pm === "bun") {
    command = `bun add ${isDev ? "-d " : ""}${packageName}`;
  } else {
    command = `npm install ${isDev ? "--save-dev " : ""}${packageName}`;
  }

  if (verbose) {
    console.log(chalk.dim(`  [Verbose] Executing command: ${command}`));
  }

  const startTime = Date.now();
  const result = await runCommandStreaming(command, { cwd, prefix: pm, verbose });
  const duration = ((Date.now() - startTime) / 1000).toFixed(1);

  if (result.code !== 0 || result.error) {
    return {
      success: false,
      details: result.stderr || result.stdout || "Command failed with exit code error.",
      command,
    };
  }

  return {
    success: true,
    details: `Successfully installed in ${duration}s.`,
    command,
  };
}
